export const settingDefinitions = {
  paymentGateway: {
    title: "درگاه پرداخت",
    description: "درگاه مورد استفاده برای پرداخت نقدی سفارش‌ها را انتخاب کنید.",
    fields: [
      { key: "gateway", label: "درگاه پرداخت", defaultValue: "saman", options: [
        { value: "saman", label: "سامان" },
        { value: "zibal", label: "زیبال" },
        { value: "payping", label: "پی‌پینگ" },
      ] },
    ],
  },
  leadOwner: {
    title: "تخصیص لیدها",
    description: "سقف تخصیص لید به پلنیوم و انتقال لیدهای بدون اپراتور را تنظیم کنید.",
    fields: [
      { key: "maxPlaniumCount", label: "سقف لیدهای پلنیوم در ۲۴ ساعت", defaultValue: 50, min: 0 },
      { key: "maxUnassignedPlaniumCount", label: "سقف لیدهای بدون اپراتور پلنیوم", defaultValue: 200, min: 0 },
    ],
  },
  formTest: {
    title: "فرم‌های پس از پرداخت",
    description: "شناسه فرم و تعداد کاربران برای تخصیص فرم پس از پرداخت را تنظیم کنید.",
    fields: [
      { key: "paypingFormId", label: "شناسه فرم پرداخت نقدی", defaultValue: 7, min: 1 },
      { key: "paypingUsersCount", label: "تعداد کاربران پرداخت نقدی", defaultValue: 4, min: 0 },
      { key: "paypingInstallmentFormId", label: "شناسه فرم اقساط پی‌پینگ", defaultValue: 7, min: 1 },
      { key: "paypingInstallmentUsersCount", label: "تعداد کاربران اقساط پی‌پینگ", defaultValue: 4, min: 0 },
      { key: "snapppayFormId", label: "شناسه فرم اسنپ‌پی", defaultValue: 7, min: 1 },
      { key: "snapppayUsersCount", label: "تعداد کاربران اسنپ‌پی", defaultValue: 4, min: 0 },
      { key: "skipPaymentFormId", label: "شناسه فرم رد کردن پرداخت (قدیمی)", min: 1 },
      { key: "skipPaymentUsersCount", label: "تعداد کاربران رد کردن پرداخت (قدیمی)", min: 0 },
    ],
  },
};

export const isObject = (value) => value !== null && typeof value === "object" && !Array.isArray(value);

export const getInitialValues = (definition, value) => definition
  ? Object.fromEntries(definition.fields.map((field) => [field.key, value?.[field.key] ?? field.defaultValue]))
  : { json: JSON.stringify(value ?? null, null, 2) };

export const getSettingValue = (definition, original, values) => {
  if (!definition) return JSON.parse(values.json);
  const result = { ...original };
  definition.fields.forEach(({ key }) => {
    if (values[key] === undefined || values[key] === null) delete result[key];
    else result[key] = values[key];
  });
  return result;
};
